import { addMessages } from '@hana/i18n';

// Khoá chuỗi Ezy › Dịch vụ › Danh mục. Mã dịch vụ, tên riêng và dữ liệu không dịch.
addMessages('vi', {
  'cat.col.stt': 'STT',
  'cat.col.code': 'Mã',
  'cat.col.vi': 'Tên dịch vụ (VN)',
  'cat.col.en': 'Tên tiếng Anh',
  'cat.col.grp': 'Nhóm',
  'cat.col.unit': 'Đơn vị',
  'cat.col.vat': 'VAT',
  'cat.col.truck': 'Vận tải',
  'cat.noWrite': 'Chưa mở ghi ở bản này',
  'cat.soon': '{what} chưa mở ở bản này',
  'cat.all': 'Tất cả',
  'cat.pub': 'Đã xuất bản',
  'cat.draft': 'Nháp',
  'cat.asks': 'Câu hỏi chờ trả lời',
  'cat.nSvc': '{n} dịch vụ',
  'cat.nCode': '{a} / {b} mã',
  'cat.nQa': '{n} tình huống',
  'cat.phIntro': 'Tìm dịch vụ theo mã / tên',
  'cat.phCode': 'Mã / tên VN / tên EN',
  'cat.phQa': 'Tìm tình huống, cách xử lý, thẻ',
  'cat.nAsks': '{n} câu',
  'cat.caseDetail': 'Chi tiết tình huống',
  'cat.unclear': 'Điểm chưa rõ',
  'cat.unclearOpen': 'Điểm chưa rõ đang mở',
  'cat.nPts': '{n} điểm',
  'cat.recent': 'Mã vừa sửa',
  'cat.recentH': 'Mã vừa thêm / sửa',
  'cat.title': 'Danh mục dịch vụ',
  'cat.back': 'Về Dịch vụ & HS',
  'cat.section': 'Mục',
  'cat.tIntro': 'Giới thiệu dịch vụ',
  'cat.tCode': 'Mã dịch vụ',
  'cat.tQa': 'Hỏi đáp',
  'cat.otherOps': 'Thao tác khác',
  'cat.opsMenu': 'Menu tác vụ',
  'cat.newQuote': 'Tạo báo giá',
  'cat.addCode': 'Thêm mã',
  'cat.addCase': 'Ghi tình huống',
  'cat.search': 'Tìm',
  'cat.codeGroup': 'Nhóm mã',
  'cat.status': 'Trạng thái',
  'cat.empty': 'Chưa có dịch vụ',
  'cat.emptyDesc': 'Danh mục dịch vụ sẽ hiện ở đây.',
  'cat.retry': 'Thử lại',
  'cat.offered': 'Dịch vụ HANA cung cấp',
  'cat.svcDetail': 'Chi tiết dịch vụ',
  'cat.noSvc': 'Không có dịch vụ khớp "{q}"',
  'cat.codeList': 'Danh mục mã dịch vụ',
  'cat.price': 'Giá 20\' / 40\'',
  'cat.del': 'Xoá',
  'cat.editCode': 'Sửa mã dịch vụ',
  'cat.inactive': 'ngừng dùng',
  'cat.yes': 'Có',
  'cat.delCode': 'Xoá mã {code}',
  'cat.delCodeT': 'Xoá mã',
  'cat.noCode': 'Không có mã khớp tìm kiếm',
  'cat.cosNote': 'Mã COS (chi phí nội bộ) quản lý ở Chi phí · xoá mã đang dùng sẽ chuyển sang ngừng dùng',
  'cat.qaFilter': 'Lọc hỏi đáp',
  'cat.hSvc': 'DỊCH VỤ',
  'cat.allSvc': 'Tất cả dịch vụ',
  'cat.hCat': 'DANH MỤC',
  'cat.allCat': 'Tất cả danh mục',
  'cat.qaList': 'Tình huống và cách xử lý',
  'cat.by': 'bởi {who}',
  'cat.nComments': '{n} góp ý',
  'cat.nUnclear': '{n} điểm chưa rõ',
  'cat.noCase': 'Chưa có tình huống nào ở mục này. Bấm "+ Ghi tình huống" hoặc "Đặt câu hỏi".',
  'cat.view': 'Xem dịch vụ {name}',
  'cat.owner': 'Phụ trách {v}',
  'cat.anchor': 'Mốc {v}',
  'cat.nFee': '{n} mã phí',
  'cat.nSteps': '{n} bước',
  'cat.nQaT': '{n} hỏi đáp',
});
addMessages('en', {
  'cat.col.stt': 'No.',
  'cat.col.code': 'Code',
  'cat.col.vi': 'Service name (VN)',
  'cat.col.en': 'English name',
  'cat.col.grp': 'Group',
  'cat.col.unit': 'Unit',
  'cat.col.vat': 'VAT',
  'cat.col.truck': 'Transport',
  'cat.noWrite': 'Write is not enabled in this version',
  'cat.soon': '{what} is not available in this version yet',
  'cat.all': 'All',
  'cat.pub': 'Published',
  'cat.draft': 'Draft',
  'cat.asks': 'Questions awaiting answers',
  'cat.nSvc': '{n} services',
  'cat.nCode': '{a} / {b} codes',
  'cat.nQa': '{n} cases',
  'cat.phIntro': 'Search services by code / name',
  'cat.phCode': 'Code / VN name / EN name',
  'cat.phQa': 'Search cases, solutions, tags',
  'cat.nAsks': '{n} questions',
  'cat.caseDetail': 'Case detail',
  'cat.unclear': 'Unclear points',
  'cat.unclearOpen': 'Open unclear points',
  'cat.nPts': '{n} points',
  'cat.recent': 'Recently edited codes',
  'cat.recentH': 'Recently added / edited codes',
  'cat.title': 'Service catalog',
  'cat.back': 'Back to Services & HS',
  'cat.section': 'Section',
  'cat.tIntro': 'Service overview',
  'cat.tCode': 'Service codes',
  'cat.tQa': 'Q&A',
  'cat.otherOps': 'Other operations',
  'cat.opsMenu': 'Actions menu',
  'cat.newQuote': 'Create quote',
  'cat.addCode': 'Add code',
  'cat.addCase': 'Log a case',
  'cat.search': 'Search',
  'cat.codeGroup': 'Code group',
  'cat.status': 'Status',
  'cat.empty': 'No services yet',
  'cat.emptyDesc': 'The service catalog will appear here.',
  'cat.retry': 'Retry',
  'cat.offered': 'Services offered by HANA',
  'cat.svcDetail': 'Service detail',
  'cat.noSvc': 'No services match "{q}"',
  'cat.codeList': 'Service code list',
  'cat.price': 'Price 20\' / 40\'',
  'cat.del': 'Delete',
  'cat.editCode': 'Edit service code',
  'cat.inactive': 'inactive',
  'cat.yes': 'Yes',
  'cat.delCode': 'Delete code {code}',
  'cat.delCodeT': 'Delete code',
  'cat.noCode': 'No codes match the search',
  'cat.cosNote': 'COS codes (internal costs) are managed in Costs · deleting a code in use marks it inactive',
  'cat.qaFilter': 'Filter Q&A',
  'cat.hSvc': 'SERVICES',
  'cat.allSvc': 'All services',
  'cat.hCat': 'CATEGORIES',
  'cat.allCat': 'All categories',
  'cat.qaList': 'Cases and solutions',
  'cat.by': 'by {who}',
  'cat.nComments': '{n} comments',
  'cat.nUnclear': '{n} unclear points',
  'cat.noCase': 'No cases in this section yet. Click "+ Log a case" or "Ask a question".',
  'cat.view': 'View service {name}',
  'cat.owner': 'Owner: {v}',
  'cat.anchor': 'Anchor: {v}',
  'cat.nFee': '{n} fee codes',
  'cat.nSteps': '{n} steps',
  'cat.nQaT': '{n} Q&A',
});
